import script from "./CockpitFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./CockpitFrame.vue?vue&type=script&setup=true&lang=js"

import "./CockpitFrame.vue?vue&type=style&index=0&id=05a04190&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05a04190"]])

export default __exports__